import { useContext } from 'react';

import { KeyboardNavigationContext } from '../contexts/KeyboardNavigationContext';

export function useKeyboardNavigationContext() {
  const context = useContext(KeyboardNavigationContext);

  return context;
}
